import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const AdditionalFields: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product?.additionalFields || context.product.additionalFields.length === 0) {
    return null;
  }

  // Filter out entries where both `value` and `key` are empty (after trimming)
  const validAdditionalFields = context.product.additionalFields.filter(
    (field) => field.value.trim() !== "" || field.key.trim() !== ""
  );

  if (validAdditionalFields.length === 0) {
    return null;
  }

  const headingColor = context.product.headingColor || "#000000";
  const textColor = context.product.textColor || "#000000";
  const headingFontStyle = context.product.headingFontStyle;
  const fontStyle = context.product.fontStyle;

  return (
    <div  
      className="mx-auto px-4 py-4 text-left border-2 rounded-md shadow-sm"
      style={{ borderColor: "rgb(0, 123, 255)", width:"90%" }}
    >
      <div className="space-y-1">
        {validAdditionalFields.map((field, index) => (
          <div key={index} className="text-sm text-gray-900">
            <span style={{ color: headingColor, fontFamily: headingFontStyle }} className="font-bold font-mulish">
            {field.key} : 
            </span>
            <span style={{ color: textColor, fontFamily: fontStyle }}>  {field.value} </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdditionalFields;
